<div class="d-flex gap-1 align-items-center">
  <span class="fs-xs">{{ description }}</span>
  <span class="text-lightgray">{{ value }}{{ value ? unit : '' }}</span>
</div>
